import { render, staticRenderFns } from "./refresh-token.vue?vue&type=template&id=72e1c904&scoped=true"
import script from "./refresh-token.vue?vue&type=script&lang=js"
export * from "./refresh-token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e1c904",
  null
  
)

export default component.exports